export function getAttendanceLevel(percentage) {
  if (percentage < 65) {
    return { level: "too-bad", text: "Muito ruim" };
  }

  if (percentage < 70) {
    return { level: "bad", text: "Ruim" };
  }

  if (percentage < 75) {
    return { level: "normal", text: "Regular" };
  }

  if (percentage < 80) {
    return { level: "good", text: "Bom" };
  }

  if (percentage < 85) {
    return { level: "very-good", text: "Muito bom" };
  }

  return { level: "great", text: "Excelente" };
}
